var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.visiblePayments, function(payment, indexPayment) {
        return _c(
          "div",
          {
            key: `payment-account-number-${indexPayment}`,
            staticClass: "bg-secondary-13 p-3 rounded mt-5"
          },
          [
            _c("div", [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("icon-view", {
                      attrs: {
                        icon: "fa fa-usd-square",
                        "icon-background": "#2DB782",
                        "icon-color": "#fff",
                        title: "Pago Parcial"
                      }
                    })
                  ],
                  1
                ),
                !_vm.hasDebtPurchaseOrderNumber(payment)
                  ? _c("div", { staticClass: "col text-center" }, [
                      _c(
                        "div",
                        { staticClass: "color-black font-16 font-weight-bold" },
                        [_vm._v(" " + _vm._s(payment.paymentNumber) + " ")]
                      )
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "col d-flex justify-content-end" }, [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("span", [_vm._v("Monto Total:")]),
                    _c(
                      "span",
                      { staticClass: "color-black font-weight-bold ml-2" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("price")(payment.purchaseTotal)) +
                            " "
                        )
                      ]
                    )
                  ])
                ]),
                !_vm.hasDebtPurchaseOrderNumber(payment)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-auto d-flex align-items-end justify-content-end"
                      },
                      [
                        _vm.cantPrintDistributionNumber && payment.paymentId
                          ? _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-print",
                                  variant: "success"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit(
                                      "print-payment-distribution",
                                      payment.paymentId
                                    )
                                  }
                                }
                              },
                              [_vm._v(" Imprimir Distribución de Pago ")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.hasDebtPurchaseOrderNumber(payment)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-1 d-flex align-items-end justify-content-end"
                      },
                      [
                        _vm.showUpdateVoucherStatus &&
                        payment.voucherNumber &&
                        (!payment.voucherTrackingInfo ||
                          !payment.voucherTrackingInfo.cashClearedDate)
                          ? _c("action-button", {
                              staticClass:
                                "btn outline-success py-1 px-0 pl-2 d-flex justify-content-center align-items-center",
                              attrs: { i: "fas fa-redo-alt" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit(
                                    "on-update-voucher-status",
                                    payment.voucherNumber
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              !payment.isDebtVoucher && !_vm.hasDebtPurchaseOrderNumber(payment)
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col ml-2 mt-2" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-gray-6 font-16 font-weight-normal mr-2"
                          },
                          [_vm._v(" PO ID: ")]
                        ),
                        _vm.showChoosePO(payment)
                          ? _c("custom-drop-down", {
                              staticClass: "w-50",
                              attrs: {
                                clearable: false,
                                fieldkey: "id",
                                fieldname: "name",
                                options: _vm.purchaseOrders,
                                placeholder: "Seleccione"
                              },
                              on: { input: _vm.onChangePurchaseOrderHandler },
                              model: {
                                value: _vm.value.purchaseOrderId,
                                callback: function($$v) {
                                  _vm.$set(_vm.value, "purchaseOrderId", $$v)
                                },
                                expression: "value.purchaseOrderId"
                              }
                            })
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "color-black font-16 font-weight-normal"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      `${payment.purchaseOrderId} (${payment.purchaseOrderBudgetYear})`
                                    ) +
                                    " "
                                )
                              ]
                            )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col d-flex align-items-center justify-content-center"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-gray-6 font-16 font-weight-normal mr-2"
                          },
                          [_vm._v(" Voucher ID: ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-black font-16 font-weight-normal"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("empty")(payment.voucherNumber)) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col d-flex justify-content-end align-items-center"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-gray-6 font-16 font-weight-normal mr-2"
                          },
                          [_vm._v(" Entry Status: ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-black font-16 font-weight-normal"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("empty")(payment.voucherStatus)) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c("div", { staticClass: "col-md-3" })
                  ])
                : _vm._e(),
              !payment.isDebtVoucher && _vm.hasDebtPurchaseOrderNumber(payment)
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-3 d-flex align-items-center" },
                      [
                        _vm._m(0, true),
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-gray-6 font-16 font-weight-normal mr-2"
                          },
                          [_vm._v(" Número de Voucher: ")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.canEditDebtVoucherInfo,
                                expression: "canEditDebtVoucherInfo"
                              }
                            ]
                          },
                          [
                            _c(
                              "validation-observer",
                              {
                                ref: `voucherNumberRef-${indexPayment}`,
                                refInFor: true,
                                attrs: { novalidate: "" }
                              },
                              [
                                _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-input", {
                                              staticClass:
                                                "custom-input__extended w-100",
                                              attrs: {
                                                "custom-error-msg":
                                                  "El voucher es requerido.",
                                                error: errors[0]
                                              },
                                              model: {
                                                value: payment.voucherNumber,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    payment,
                                                    "voucherNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "payment.voucherNumber"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        !_vm.canEditDebtVoucherInfo && payment.voucherNumber
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "color-black font-16 font-weight-normal"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("empty")(payment.voucherNumber)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col d-flex justify-content-end align-items-center"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-gray-6 font-16 font-weight-normal mr-2"
                          },
                          [_vm._v(" Fecha de Voucher: ")]
                        ),
                        _c(
                          "validation-observer",
                          {
                            ref: `voucherDateRef-${indexPayment}`,
                            refInFor: true,
                            attrs: { novalidate: "" }
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-date-picker", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.canEditDebtVoucherInfo,
                                              expression:
                                                "canEditDebtVoucherInfo"
                                            }
                                          ],
                                          key: `voucher-date-${_vm.voucherDateKey}`,
                                          attrs: {
                                            "custom-error-msg":
                                              "La fecha de voucher es requerida.",
                                            error: errors[0]
                                          },
                                          model: {
                                            value: payment.voucherDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                payment,
                                                "voucherDate",
                                                $$v
                                              )
                                            },
                                            expression: "payment.voucherDate"
                                          }
                                        }),
                                        !_vm.canEditDebtVoucherInfo &&
                                        payment.voucherDate
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("date")(
                                                      payment.voucherDate
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col d-flex justify-content-end" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-end p-0"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "color-gray-6 font-16 font-weight-normal mr-3"
                              },
                              [_vm._v(" Número de Pago: ")]
                            ),
                            _c(
                              "span",
                              [
                                _c(
                                  "validation-observer",
                                  {
                                    ref: `paymentIdFormRef-${indexPayment}`,
                                    refInFor: true,
                                    attrs: { novalidate: "" }
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-input", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.canEditDebtVoucherInfo,
                                                      expression:
                                                        "canEditDebtVoucherInfo"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "custom-input__extended mr-2",
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "El número de pago es requerido.",
                                                    error: errors[0],
                                                    maxlength: "50"
                                                  },
                                                  model: {
                                                    value:
                                                      payment.paymentNumber,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        payment,
                                                        "paymentNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "payment.paymentNumber"
                                                  }
                                                }),
                                                _c(
                                                  "div",
                                                  [
                                                    errors[0] &&
                                                    !_vm.isOldBilling
                                                      ? _c("error", {
                                                          staticStyle: {
                                                            position:
                                                              "relative",
                                                            top: "1.3em",
                                                            right: "9em"
                                                          },
                                                          attrs: {
                                                            message:
                                                              "El número de pago es requerido.",
                                                            variant: "no-border"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            !_vm.canEditDebtVoucherInfo
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-black font-16 font-weight-normal mr-5"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("empty")(payment.paymentNumber)
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col d-flex justify-content-end align-items-center"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-gray-6 font-16 font-weight-normal mr-2"
                          },
                          [_vm._v(" Fecha de Pago: ")]
                        ),
                        _c(
                          "validation-observer",
                          {
                            ref: `paymentDateRef-${indexPayment}`,
                            refInFor: true,
                            attrs: { novalidate: "" }
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-date-picker", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.canEditDebtVoucherInfo,
                                              expression:
                                                "canEditDebtVoucherInfo"
                                            }
                                          ],
                                          attrs: {
                                            "custom-error-msg":
                                              "La fecha de pago es requerida.",
                                            error: errors[0]
                                          },
                                          model: {
                                            value: payment.paymentDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                payment,
                                                "paymentDate",
                                                $$v
                                              )
                                            },
                                            expression: "payment.paymentDate"
                                          }
                                        }),
                                        _c(
                                          "div",
                                          [
                                            errors[0] &&
                                            !_vm.canEditDebtVoucherInfo
                                              ? _c("error", {
                                                  staticStyle: {
                                                    position: "relative",
                                                    top: "1.3em",
                                                    right: "9em"
                                                  },
                                                  attrs: {
                                                    message:
                                                      "La fecha de pago es requerida.",
                                                    variant: "no-border"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        !_vm.canEditDebtVoucherInfo
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "color-black font-16 font-weight-normal"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("date")(payment.paymentDate)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-auto d-flex align-items-end justify-content-end"
                      },
                      [
                        _vm.hasDebtPurchaseOrderNumber(payment) &&
                        _vm.canEditDebtVoucherInfo
                          ? _c("action-button", {
                              staticClass: "mb-1",
                              attrs: {
                                i: "fas fa-save",
                                variant: "outline-success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onSaveVoucherInfo(
                                    payment,
                                    indexPayment
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    payment.voucherTrackingInfo &&
                    payment.voucherTrackingInfo.voucherStatusReason
                      ? _c("error", {
                          staticStyle: { border: "none" },
                          attrs: {
                            message:
                              "<b>Razón de Cancelación: </b>" +
                              payment.voucherTrackingInfo.voucherStatusReason,
                            variant: "custom-error-extended"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]),
            _c("hr"),
            _vm._l(payment.billingPurchaseOrderNumbers, function(item, index) {
              return _c(
                "div",
                {
                  key: `account-number-${index}`,
                  staticClass: "row bg-white m-1 rounded p-3 mb-2"
                },
                [
                  _c("div", { staticClass: "col-md-4 mt-1" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Número de Cifra: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16" }, [
                      _vm._v(" " + _vm._s(item.fullNumber) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm mt-1" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Número de lí­nea: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16" }, [
                      _vm._v(" " + _vm._s(item.lineNumber) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm mt-1" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Tipo de Cifra: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16" }, [
                      _vm._v(" " + _vm._s(item.digitType) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm mt-1" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Grupo de edad: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16" }, [
                      _vm._v(" " + _vm._s(item.ageRange) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm mt-3 mt-md-1 mt-sm-3" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Monto: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16 font-14" }, [
                      _vm._v(" " + _vm._s(_vm._f("price")(item.amount)) + " ")
                    ])
                  ]),
                  _vm.canRemoveDebtVoucherInfo &&
                  (!payment.voucherNumber ||
                    _vm.hasDebtPurchaseOrderNumber(payment))
                    ? _c(
                        "div",
                        { staticClass: "col-sm mt-1 mr-3 mr-md-0 mr-sm-3" },
                        [
                          _c(
                            "action-button",
                            {
                              attrs: {
                                i: "fas fa-times-circle",
                                variant:
                                  "outline-danger btn-cancel danger m-2 pr-4"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteBillingDigit(item)
                                }
                              }
                            },
                            [_vm._v(" Eliminar ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            }),
            _vm.showBillPaymentForm(payment) && payment.isDebtVoucher
              ? _c(
                  "div",
                  { staticClass: "row bg-white mt-3 rounded p-2 mx-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("icon-view", {
                          staticClass: "mb-3",
                          attrs: {
                            gradient: "",
                            icon: "fa fa-dollar-sign",
                            "icon-background": "#FF7058",
                            "icon-color": "#fff",
                            title: "Adjudicación por Cifra de Cuenta"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 mt-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v(" Número de Voucher: ")]
                        ),
                        _c(
                          "validation-observer",
                          {
                            ref: "debtVoucherNumberRef",
                            refInFor: true,
                            attrs: { novalidate: "" }
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          staticClass:
                                            "custom-input__extended w-100",
                                          attrs: {
                                            "custom-error-msg":
                                              "El voucher es requerido.",
                                            disabled: !_vm.canEditVoucherInfo,
                                            error: errors[0]
                                          },
                                          model: {
                                            value:
                                              _vm.debtVoucherForm.voucherNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.debtVoucherForm,
                                                "voucherNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "debtVoucherForm.voucherNumber"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 mt-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v(" Fecha de Voucher: ")]
                        ),
                        _c(
                          "validation-observer",
                          {
                            ref: "debtVoucherDateRef",
                            refInFor: true,
                            attrs: { novalidate: "" }
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-date-picker", {
                                          attrs: {
                                            "custom-error-msg":
                                              "La fecha de voucher es requerida.",
                                            disabled: !_vm.canEditVoucherInfo,
                                            error: errors[0]
                                          },
                                          model: {
                                            value:
                                              _vm.debtVoucherForm.voucherDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.debtVoucherForm,
                                                "voucherDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "debtVoucherForm.voucherDate"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 mt-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v(" Número de Pago: ")]
                        ),
                        _c(
                          "validation-observer",
                          {
                            ref: "debtPaymentNumberRef",
                            refInFor: true,
                            attrs: { novalidate: "" }
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: _vm.requireDebtPaymentFields
                                  ? "required"
                                  : ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          staticClass:
                                            "custom-input__extended w-100",
                                          attrs: {
                                            "custom-error-msg":
                                              "El número de pago es requerido.",
                                            disabled: !_vm.canEditVoucherInfo,
                                            error: errors[0]
                                          },
                                          model: {
                                            value:
                                              _vm.debtVoucherForm.paymentNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.debtVoucherForm,
                                                "paymentNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "debtVoucherForm.paymentNumber"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 mt-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v(" Fecha de Pago: ")]
                        ),
                        _c(
                          "validation-observer",
                          {
                            ref: "debtPaymentDateRef",
                            refInFor: true,
                            attrs: { novalidate: "" }
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: _vm.requireDebtPaymentFields
                                  ? "required"
                                  : ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-date-picker", {
                                          attrs: {
                                            "custom-error-msg":
                                              "La fecha de pago es requerida.",
                                            disabled: !_vm.canEditVoucherInfo,
                                            error: errors[0]
                                          },
                                          model: {
                                            value:
                                              _vm.debtVoucherForm.paymentDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.debtVoucherForm,
                                                "paymentDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "debtVoucherForm.paymentDate"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm.showBillPaymentForm(payment)
              ? _c(
                  "validation-observer",
                  {
                    ref: "billPaymentForm",
                    refInFor: true,
                    attrs: { novalidate: "", tag: "form" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row bg-white mt-3 rounded p-2 mx-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c(
                              "div",
                              { staticClass: "color-secondary-4 font-14" },
                              [_vm._v(" Número de Cifra: ")]
                            ),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          staticClass: "w-75",
                                          attrs: {
                                            clearable: false,
                                            "custom-error-msg":
                                              "Favor seleccionar al menos una cifra de cuenta.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            options: _vm.paymentDigitList,
                                            placeholder: "Seleccione"
                                          },
                                          on: {
                                            input: _vm.onPurchaseOrderChange
                                          },
                                          model: {
                                            value:
                                              _vm.value.purchaseOrderNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.value,
                                                "purchaseOrderNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "value.purchaseOrderNumber"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-sm mt-1 pl-5" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v(" Número de lí­nea: ")]
                          ),
                          _c("div", { staticClass: "color-black font-16" }, [
                            _vm._v(" " + _vm._s(_vm.lineNumber) + " ")
                          ])
                        ]),
                        _c("div", { staticClass: "col-sm mt-1 pl-5" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v(" Tipo de Cifra: ")]
                          ),
                          _c("div", { staticClass: "color-black font-16" }, [
                            _vm._v(" " + _vm._s(_vm.digitType) + " ")
                          ])
                        ]),
                        !payment.isDebtVoucher
                          ? _c("div", { staticClass: "col-sm mt-1 pl-5" }, [
                              _c(
                                "div",
                                { staticClass: "color-secondary-6 font-14" },
                                [_vm._v(" Grupo de Edad: ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "color-black font-16" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.billingServiceCategoryName) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        !payment.isDebtVoucher
                          ? _c(
                              "div",
                              { staticClass: "col-sm mt-3 mt-md-1 mt-sm-3" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "color-secondary-6 font-14" },
                                  [_vm._v(" Balance: ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "color-secondary-6font-14" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm._f("price")(_vm.balance)) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "col-sm mt-3 mr-4 mt-md-1 mt-sm-3" },
                          [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v(" Monto: ")]
                            ),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "input-group mb-3" },
                                          [
                                            _c("custom-input", {
                                              staticClass:
                                                "custom-input__extended w-100",
                                              attrs: {
                                                "custom-error-msg":
                                                  "Campo Requerido",
                                                error: errors[0],
                                                "mask-type": "Money",
                                                "prepend-icon":
                                                  "fa fa-dollar-sign",
                                                "prepend-icon-left": true,
                                                "prepend-icon-type": "success"
                                              },
                                              model: {
                                                value: _vm.value.amount,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.value,
                                                    "amount",
                                                    $$v
                                                  )
                                                },
                                                expression: "value.amount"
                                              }
                                            }),
                                            errors[0]
                                              ? _c("error", {
                                                  attrs: {
                                                    message:
                                                      "Favor de entrar el monto. (0326).",
                                                    variant: "no-border"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-12 mt-1 d-flex align-items-center justify-content-end"
                          },
                          [
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-times-circle",
                                  variant: "outline-danger btn-cancel danger"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelBillingDigit()
                                  }
                                }
                              },
                              [_vm._v(" Cancelar ")]
                            ),
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-save",
                                  variant: "success m-2 pl-4 pr-4"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.saveBillingDigit(payment)
                                  }
                                }
                              },
                              [_vm._v(" Guardar ")]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    !_vm.isValidAmountForGrant && !payment.isDebtVoucher
                      ? _c("error", {
                          staticClass: "pt-2 ml-2",
                          attrs: {
                            "is-alert-mode": "",
                            message:
                              "El monto ingresado supera el disponible en el detalle de la factura para este grupo. Te recomendamos verificar e ingresar un monto válido."
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "row ml-2 mt-3" }, [
              _vm.showProof(payment)
                ? _c(
                    "div",
                    { staticClass: "col-md-3 d-flex align-items-center" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-secondary-6 font-14 mr-2" },
                        [_vm._v(" Número de Voucher: ")]
                      ),
                      _c("span", { staticClass: "color-black font-16" }, [
                        _vm._v(" " + _vm._s(payment.voucherNumber) + " ")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.showProof(payment)
                ? _c(
                    "div",
                    { staticClass: "col-md-3 d-flex align-items-center" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-secondary-6 font-14 mr-2" },
                        [_vm._v(" Número de Cheque: ")]
                      ),
                      _c("span", { staticClass: "color-black font-16" }, [
                        _vm._v(" " + _vm._s(payment.paymentIdReference) + " ")
                      ])
                    ]
                  )
                : _vm._e(),
              !_vm.isPayment(payment) &&
              !payment.voucherNumber &&
              !payment.isDebtVoucher
                ? _c(
                    "div",
                    {
                      class:
                        _vm.isPayment(payment) && !payment.voucherNumber
                          ? "col-md-6 text-right mt-1"
                          : "col-md-12 text-right mt-1"
                    },
                    [
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-times-circle",
                            variant: "outline-danger btn-cancel danger mt-3"
                          },
                          on: {
                            click: function($event) {
                              return _vm.cancelPartialPayment(payment)
                            }
                          }
                        },
                        [_vm._v(" Cancelar Pago Parcial ")]
                      ),
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-file-plus",
                            variant: "outline-success m-2 pl-3 pr-3"
                          },
                          on: {
                            click: function($event) {
                              return _vm.addPayment(payment)
                            }
                          }
                        },
                        [_vm._v(" Añadir Cifra ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm.showTrackingInfo(payment)
              ? _c(
                  "div",
                  { staticClass: "mt-4 bg-gray-9 rounded p-3" },
                  [
                    _c("voucher-and-payment-status-info", {
                      attrs: { info: payment.voucherTrackingInfo }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._t("documents", null, null, { payment })
          ],
          2
        )
      }),
      _vm.billInfo.payments.length == 0 && !_vm.isApprovedStatus
        ? _c(
            "callout",
            { attrs: { "border-color": "secondary-2", "class-main": "py-3" } },
            [
              _c("div", { staticClass: "row justify-content-center" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-3 ml-lg-n4 align-self-center" },
                  [
                    _c("span", { staticClass: "no-info-text" }, [
                      _vm._v("No hay información disponible.")
                    ])
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      !_vm.hasActiveDebtVoucher
        ? _c("div", { staticClass: "d-flex justify-content-end mt-3" }, [
            _c(
              "div",
              [
                _vm.canAddVoucher
                  ? _c("action-button", {
                      attrs: {
                        i: "fas fa-file-plus",
                        text: "Añadir Voucher",
                        variant: "success"
                      },
                      on: { click: _vm.onAddVoucherClick }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ml-3" },
              [
                _vm.canAddDebtVoucher
                  ? _c("action-button", {
                      attrs: {
                        i: "fas fa-file-plus",
                        text: "Documentar Voucher de Deuda",
                        variant: "success"
                      },
                      on: { click: _vm.addDebtVoucherPayment }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "fa-stack fa-1x color-green font-14 mr-3" },
      [
        _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
        _c("em", { staticClass: "fas fa-usd-square fa-stack-1x fa-inverse" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }